module.exports = __webpack_public_path__ + "static/media/nube_harina de trigo.fcd41b2b.png";